/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken } from '../utils/util';
import './MyProfile.css';
import Wrapper from './Wrapper';
import {
  fetchUser,
  listRooms,
  createEscape,
  deleteEscape,
  updateEscape,
} from '../actions';
import EscapeForm from './partials/EscapeForm';


class Escape extends Component {

  deleteEscape() {
    this.props.deleteEscape(this.props.escape.id)
      .then(resp => {
        if (resp.error) return;
        return this.props.fetchUser();
      });
  }

  render() {
    let escape = this.props.escape;
    console.log('render escape:', escape);
    return (
      <div className={cx('Escape', { yes: escape.didEscape, no: !escape.didEscape })}>
        <div className="room-name">{escape.room.name}</div>
        <div className="escape-description">
          <div className="did-escape">
            {escape.didEscape && 'You ESCAPED!'}
            {!escape.didEscape && 'You did NOT escape...'}
          </div>
          {escape.didEscape && <div className="your-time">Your time: {escape.time} minutes</div>}
        </div>
        <div className="escape-buttons">
          <Button
            bsSize="small"
            bsStyle="default"
            onClick={() => this.deleteEscape()}>Remove</Button>{' '}
          <Button
            bsSize="small"
            bsStyle="default"
            onClick={() => this.props.onEdit(escape.id)}>Edit</Button>
        </div>
      </div>
    );
  }
}

Escape = connect(
  () => { return {} },
  (dispatch) => mapDispatch(dispatch, { fetchUser, deleteEscape }),
)(Escape);


class MyProfile extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['rooms', listRooms],
  ];

  state = {};

  editEscape(e, values) {
    e.preventDefault();
    this.props.updateEscape(this.state.editingEscape, values)
      .then(resp => {
        if (resp.error) return;
        this.props.fetchUser()
          .then(resp => {
            this.closeEditEscape();
            NotificationManager.success('Updated the escape!');
          });
      });
  }

  closeEditEscape() {
    this.setState({ editingEscape: false });
  }

  renderEditEscape() {
    if (!this.props.user) {
      return;
    }
    let rooms = this.props.rooms ? this.props.rooms.items : [];
    let escape = {};
    for (let e of this.props.user.profile.escapes) {
      if (e.id == this.state.editingEscape) {
        escape = e;
      }
    }
    return (
      <Modal show={!!this.state.editingEscape}>
        <Modal.Header closeButton onHide={() => this.closeEditEscape()}>
          <Modal.Title>Edit Escape</Modal.Title>
        </Modal.Header>
        <EscapeForm
          modal={true}
          values={escape}
          errors={this.props.errors.escape}
          onSubmit={(e, values) => this.editEscape(e, values)}
          onCancel={() => this.closeEditEscape()}
          buttonText="Save"
          cancelText="Cancel"
          rooms={rooms}
        />
      </Modal>
    );
  }

  addEscape(e, values) {
    e.preventDefault();
    console.log('call create with:', values);
    this.props.createEscape(values)
      .then(resp => {
        if (!resp.error) {
          this.props.fetchUser()
            .then(resp => {
              this.closeAddEscape();
              NotificationManager.success('Added the escape!');
            });
        }
      })
  }

  closeAddEscape() {
    this.setState({ addingEscape: false });
  }

  renderAddEscape() {
    let rooms = this.props.rooms ? this.props.rooms.items : [];
    return (
      <Modal show={!!this.state.addingEscape}>
        <Modal.Header closeButton onHide={() => this.closeAddEscape()}>
          <Modal.Title>Add Escape</Modal.Title>
        </Modal.Header>
        <EscapeForm
          modal={true}
          values={{}}
          errors={this.props.errors.escape}
          onSubmit={(e, values) => this.addEscape(e, values)}
          onCancel={() => this.closeAddEscape()}
          buttonText="Add"
          cancelText="Cancel"
          rooms={rooms}
        />
      </Modal>
    );
  }

  renderUser() {
    let user = this.props.user;
    let count = 0;
    let total = user.profile.escapes.length;
    for (let escape of user.profile.escapes) {
      if (escape.didEscape) {
        count++;
      }
    }
    let percent = 0;
    if (total) {
      percent = Math.round(100 * count / total);
    }

    let nodes = user.profile.escapes.map(escape => {
      return (
        <Escape
          escape={escape}
          onEdit={(id) => this.setState({ editingEscape: id })} />
      );
    });

    let escapeSummary = null;
    if (total) {
      escapeSummary = (
        <div className="escape-summary">
          <div className="escape-rate-wrapper">
            <div className="escape-rate">{percent}%</div>
            <div>Your escape rate</div>
          </div>
          <div>Rooms attempted: <b>{total}</b>, escaped: <b>{count}</b></div>
        </div>
      );
    }

    return (
      <div>
        {escapeSummary}

        <div>
          <div className="escapes">{nodes}</div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="MyProfile" title="Your Profile">
        <div className="control-buttons">
          <Button
            bsStyle="primary"
            onClick={() => this.setState({ addingEscape: true })}
          >Add Escape</Button>{' '}
        </div>

        {this.renderAddEscape()}
        {this.renderEditEscape()}

        {this.props.user && this.renderUser()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    rooms: state.list.room,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    fetchUser,
    createEscape,
    updateEscape,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MyProfile);



/** WEBPACK FOOTER **
 ** ./src/components/MyProfile.js
 **/